module.exports = __webpack_public_path__ + "img/icb-leo-elite-m.3b63007d.png";